import { parseEnv } from '@/helpers/route-utils';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { EVENT_TYPES } from 'utils';
import * as z from 'zod/v4';

export const Route = createFileRoute('/_auth/$env/templates/all')({
  params: parseEnv(),
  validateSearch: zodValidator(
    z.object({
      search: z.string().optional().default(''),
      eventType: z.enum(EVENT_TYPES).optional(),
      page: z.number().optional().default(1),
      pageSize: z.number().optional().default(10),
    }),
  ),
});
